export default "__VITE_ASSET__BHparU0m__"